// Custom-door builder (step 2). Wrapped in an IIFE to avoid global collisions with ikea-new-setup.js.
(function () {
// Identifies which configurator this page is (e.g. "kitchen-builder" /
// "wardrobe-builder"), so doors added here can be tagged and the edge/handle
// steps only show doors belonging to THIS configurator (no kitchen↔wardrobe leak).
function getBuilderType() {
  const el = document.querySelector("[data-builder-type]");
  return (el && el.dataset.builderType) || "";
}
document
  .querySelectorAll(
    ".section-product-builder .custom-option-section .functional",
  )
  .forEach((el) => {
    el.addEventListener("click", () => {
      const builder = document.querySelector(".section-product-builder");
      const ikeaStepSection = document.querySelector(
        ".custom-option-section.IKEA-step",
      );

      const allSections = Array.from(
        builder.querySelectorAll(".custom-option-section"),
      );
      const customSection = document.querySelector(".main-product-custom");
      const currentSection = el.closest(".custom-option-section");
      const optionName = el.dataset.optionName;
      const optionValue = el.dataset.optionValue;

      const currentIndex = allSections.indexOf(currentSection);

      allSections.forEach((sec, idx) => {
        if (idx > currentIndex) sec.classList.remove("active");
      });

      allSections.forEach((sec, idx) => {
        if (idx <= currentIndex) sec.classList.add("active");
      });

      currentSection
        .querySelectorAll(".functional")
        .forEach((f) => f.classList.remove("selected"));
      el.classList.add("selected");

      const nextSection = allSections[currentIndex + 1];
      if (nextSection) nextSection.classList.add("active");

      if (optionName === "IKEA") {
        // if (customSection) customSection.style.display = 'none';
        if (ikeaStepSection) ikeaStepSection.classList.add("active");
      }

      if (optionName === "Custom" && customSection) {
        customSection.style.display = "block";
        if (ikeaStepSection) ikeaStepSection.classList.remove("active");
      }

      if (optionName === "Material") {
        document
          .querySelectorAll(
            'input#material[type="hidden"][name="properties[Material]"]',
          )
          .forEach((input) => {
            input.value = optionValue || "";
          });
        currentSection.querySelector('.input-cart-option[name="color"]').value =
          optionValue;
      }
    });
  });

// Hide "Filter--Panel" option from every .filter-select on page load
document.querySelectorAll(".filter-select").forEach((select) => {
  const panelOption = Array.from(select.options).find(
    (opt) => opt.value === "Filter--Panel",
  );
  if (panelOption) panelOption.hidden = true;
});

document.querySelectorAll(".filter-select").forEach((select) => {
  select.addEventListener("change", () => {
    const filterValue = select.value.toLowerCase();
    const ikeaButton = document.querySelector(".js-ikea-dynamic-button");
    const container = document.querySelector(".ikea-products");
    if (!container) return;

    const items = container.querySelectorAll(".grid__item");

    if (filterValue === "Filter--Panel") {
      if (ikeaButton) {
        ikeaButton.textContent = "Checkout";
      }
    } else {
      if (ikeaButton) {
        ikeaButton.textContent = "Next Step";
      }
    }

    items.forEach((item) => {
      const dataFilter = item.getAttribute("data-filter")?.toLowerCase() || "";
      if (filterValue === "all" || dataFilter.includes(filterValue)) {
        item.style.display = "";
      } else {
        item.style.display = "none";
      }
    });
  });
});

document
  .querySelectorAll('.set_endings .radio_group input[type="radio"]')
  .forEach((radio) => {
    radio.addEventListener("change", (e) => {
      const endingInfo = e.target
        .closest(".product-endings")
        ?.querySelector(".endings_setup");
      const input = radio
        .closest(".custom-option-section")
        ?.querySelector('.input-cart-option[name="door_option_added"]');
      if (!endingInfo) return;

      if (radio.checked) {
        if (radio.value === "yes") {
          endingInfo.style.display = "block";
        } else if (radio.value === "no") {
          endingInfo.style.display = "none";
        }
      }
      if (input) input.value = radio.value;
    });
  });

document
  .querySelectorAll('.set_hadles .radio_group input[type="radio"]')
  .forEach((radio) => {
    radio.addEventListener("change", (e) => {
      const endingInfo = e.target
        .closest(".product-endings")
        ?.querySelector(".handles_setup");
      const input = radio
        .closest(".custom-option-section")
        ?.querySelector('.input-cart-option[name="door_option_added"]');
      if (!endingInfo) return;

      if (radio.checked) {
        if (radio.value === "yes") {
          endingInfo.style.display = "block";
        } else if (radio.value === "no") {
          endingInfo.style.display = "none";
        }
      }
      if (input) input.value = radio.value;
    });
  });

document.querySelectorAll(".circle").forEach((circle) => {
  circle.addEventListener("click", function () {
    if (this.classList.contains("active")) {
      this.classList.remove("active");
    } else {
      this.classList.add("active");
    }
  });
});

document
  .querySelectorAll('.brackets-select input[type="radio"][name="bracket"]')
  .forEach((radio) => {
    radio.addEventListener("click", () => {
      document.querySelector(".main-product-custom").style.display = "block";

      if (radio.value === "Yes") {
        const trueRadio = document.querySelector(
          'input[data-identifier="Bracket"][data-val="1"]',
        );
        if (trueRadio) {
          trueRadio.click();
        } else {
          document.addEventListener("DOMContentLoaded", () => {
            const trueRadioDelayed = document.querySelector(
              'input[data-identifier="Bracket"][data-val="1"]',
            );
            if (trueRadioDelayed) trueRadioDelayed.click();
          });
        }
      } else if (radio.value === "No") {
        const falseRadio = document.querySelector(
          'input[data-identifier="Bracket"][data-val="0"]',
        );
        if (falseRadio) {
          falseRadio.click();
        } else {
          document.addEventListener("DOMContentLoaded", () => {
            const falseRadioDelayed = document.querySelector(
              'input[data-identifier="Bracket"][data-val="0"]',
            );
            if (falseRadioDelayed) falseRadioDelayed.click();
          });
        }
      }
    });
  });

// Card adds run one after another so a quick second click numbers its door
// (and column) against the cart that already holds the first one.
let cardAddQueue = Promise.resolve();

document
  .querySelectorAll('.form .quick-add__submit[type="button"]')
  .forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      cardAddQueue = cardAddQueue
        .then(() => addCardToCart(button))
        .catch((err) => console.error(err));
    });
  });

async function addCardToCart(button) {
  const form = button.closest(".form");
  const actionButtons = form ? form.querySelectorAll(".js-ikea-add-button") : [button];

  actionButtons.forEach(btn => {
    btn.classList.add("loading");
  });
  const doorType = button.dataset.doorType || "";
  const [doorNumber, doorColumn] = await Promise.all([
    nextDoorNumber(),
    doorType ? nextDoorColumn(doorType) : Promise.resolve(""),
  ]);
  const finishImage = selectedFinishImageUrl();
  const items = [
    {
      id: form.querySelector('input[name="id"]').value,
      quantity: 1,
      properties: {
        Material:
          form.querySelector('input[name="properties[Material]"]')?.value ||
          "",
        // IKEA door cards have one add button per position ("to the
        // right" / "above"); other cards fall back to the hidden input.
        Type:
          doorType ||
          form.querySelector('input[name="properties[Type]"]')?.value ||
          "",
        // Which column of the run the door goes in: "to the right"
        // opens the next column, "above" stacks on the last door's.
        ...(doorColumn ? { Column: doorColumn } : {}),
        _Number: generatePropertyNumber(),
        _DoorSeq: nextDoorSequence(),
        // IKEA door products carry no images of their own, so the cart
        // shows the chosen finish instead (see cart-line-image snippet).
        ...(finishImage ? { _Image: finishImage } : {}),
        ...(doorNumber ? { Door: doorNumber } : {}),
        ...(getBuilderType() ? { _Builder: getBuilderType() } : {}),
      },
    },
  ];
  // await fetch("/cart/add.js", {
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Accept: "application/json",
  //   },
  //   body: JSON.stringify({ items }),
  // });

  // actionButtons.forEach(btn => {
  //     btn.disabled = true;
  //     btn.classList.remove("loading");
  //     btn.classList.add("disabled", "is-added");
  //     btn.style.opacity = "0.5";
  //     btn.style.cursor = "not-allowed";
  //     btn.style.pointerEvents = "none";
      
  //     const label = btn.querySelector(".ikea-door-action__label");
  //     if (label) {
  //       label.textContent = "✓ Door added to your bag";
  //     }
  //   });
  try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        console.warn("[IKEA-DOOR] /cart/add.js failed:", data && data.message);
        return;
      }
    } finally {
      actionButtons.forEach((btn) => btn.classList.remove("loading"));
    }
  const drawer = document.querySelector("cart-drawer");
  if (drawer && typeof drawer.onCartUpdate === "function") {
    drawer.onCartUpdate();
    drawer.classList.remove("is-empty");
    const innerEmpty = drawer.querySelector(".drawer__inner-empty");
    if (innerEmpty) innerEmpty.remove();
    drawer.querySelector("cart-drawer-items").classList.remove("is-empty");
    const counter = document.querySelector(
      "#cart-icon-bubble .cart-count-bubble",
    );
    const totalPrice = document.querySelector(
      "#CartDrawer .totals__total-value .number",
    );
    const response = await fetch("/cart.js");
    const data = await response.json();
    const innerText = `
					<span aria-hidden="true">${data.items.length}</span>
					<span class="visually-hidden">${data.items.length} item</span>
					`;
    if (totalPrice) {
      totalPrice.innerHTML = (data.items_subtotal_price / 100).toFixed(2);
    }
    if (counter) {
      counter.innerHTML = innerText;
    } else {
      const bubble = document.createElement("div");
      bubble.className = "cart-count-bubble";
      bubble.innerHTML = innerText;
      document.querySelector("#cart-icon-bubble").appendChild(bubble);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {

  function unlockCustomDoorButton() {
    const addDoorBtn = document.querySelector(".door-builder-add-to-bag");
    if (!addDoorBtn) return;

    addDoorBtn.disabled = false;
    addDoorBtn.classList.remove("disabled", "is-added");
    addDoorBtn.style.opacity = "";
    addDoorBtn.style.cursor = "";
    addDoorBtn.style.pointerEvents = "";

    if (addDoorBtn.dataset.originalLabel) {
      addDoorBtn.textContent = addDoorBtn.dataset.originalLabel;
    }
  }

  document.addEventListener("click", function (e) {
    if (
      e.target.closest("product-endings .edge_type:not(.edge_type--custom)")
    ) {
      let positionData;
      if (e.target.classList.contains("edge_type")) {
        positionData = e.target.dataset.value;
      } else {
        positionData = e.target.closest(".edge_type").dataset.value;
      }
      const positionInput = document.querySelector(
        '.input-cart-option[name="edge_position"]',
      );
      positionInput.value = positionData;

      // Picking a preset clears the custom total.
      const productEndings = e.target.closest("product-endings");
      if (productEndings) renderCustomEdgeTotal(productEndings);
    }
    if (e.target.closest("product-endings .edge_type_option")) {
      const optionEl = e.target.closest(".edge_type_option");
      // The centre square is decorative / non-interactive.
      if (!optionEl.classList.contains("square")) {
        const productEndings = optionEl.closest("product-endings");
        const customCard = optionEl.closest(".edge_type--custom");
        const positionInput = document.querySelector(
          '.input-cart-option[name="edge_position"]',
        );

        // Active classes are toggled by the product-endings component (which
        // runs first on bubble); read them here to build the multi-select list.
        const selected = customCard
          ? Array.from(
              customCard.querySelectorAll(
                ".edge_type_option.active:not(.square)",
              ),
            ).map((el) => el.dataset.value)
          : [];

        positionInput.value = selected.join(", ");
        if (productEndings) renderCustomEdgeTotal(productEndings);
      }
    }
    // Per-door "Clear handle selection" for the custom-door flow. Resets the
    // diagram and clears the stored handle so nothing is added on submit. Scoped
    // to <handles-setup> so it never collides with the IKEA flow's own clear.
    const clearHandleBtn = e.target.closest(
      'handles-setup .clear-handle-selection[data-component="clear-handle"]',
    );
    if (clearHandleBtn && !e.target.closest("ikea-handles-setup")) {
      const section = clearHandleBtn.closest(".handles-option-section");
      if (section) clearCustomHandleSelection(section);
      return;
    }
    if (e.target.closest(".door-builder-add-to-bag")) {
      addCustomDoorToCart(e, refreshCartDrawer);
      return;
    }
    // "Add another door" only starts a new configuration (the inline script in
    // product-builder-step2.liquid scrolls back to the size step) — it must
    // never add to the cart. The previous door's edging and handle choices
    // are cleared so the next door starts from the defaults.
    if (e.target.closest(".door-builder-add-to-another")) {
      resetCustomDoorOptions();
      setAddAnotherDoorEnabled(false);
      
      const widthHeightBlock = document.getElementById("custom-calculator") || document.querySelector(".custom-calculator");
      if (widthHeightBlock) {
        scrollToBuilderStep(widthHeightBlock);
      }
      return;
    }
    if (e.target.closest(".door-builder-add-panels")) {
      prepeareUrlForPanels();
      return;
    }
    if (e.target.closest(".door-builder-add-to-cart")) {
      callCartOpen();
      return;
    }
  });

  const urlParams = new URLSearchParams(window.location.search);
  const materialFromUrl = urlParams.get("material");
  if (materialFromUrl) {
    document.querySelectorAll(".quick-add .form").forEach((form) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[Material]";
      input.value = materialFromUrl;
      form.appendChild(input);
    });
  }

  // A shopper who reloads the page after adding a custom door must still be
  // able to use "Go to checkout" / "View panels" — check the live cart for an
  // existing custom-door line and unlock them. "Add another door" waits for
  // the door on screen to be added.
  fetch("/cart.js")
    .then((res) => res.json())
    .then((data) => {
      const hasDoor = (data.items || []).some(
        (item) => item.properties && item.properties._DoorSeq,
      );
      if (hasDoor) setCustomDoorExitsEnabled(true);
    })
    .catch(() => {});

  // Editing the size of the door means a new door is being configured, so
  // "Add another door" locks again until that door is in the cart too. Only
  // shopper edits count (isTrusted), not the resets done in code.
  const customCalculator = document.getElementById("custom-calculator");
  if (customCalculator) {
    const lockAddAnother = (e) => {
      if (e.isTrusted) {
        setAddAnotherDoorEnabled(false);
        unlockCustomDoorButton();
      }
    };
    customCalculator.addEventListener("input", lockAddAnother);
    customCalculator.addEventListener("change", lockAddAnother);
  }
});

function prepeareUrlForPanels() {
   const materialInput = document.querySelector(
     'input#material[type="hidden"][name="properties[Material]"]',
   );
   const material = materialInput ? materialInput.value : "";
   const url = new URL("/collections/panels", window.location.origin);
   if (material) url.searchParams.set("material", material);
   window.location.href = url.toString();
}

function generatePropertyNumber() {
  return `${Date.now().toString().slice(-4)}-${Math.floor(Math.random() * 1000)}`;
}

// CDN URL of the finish the shopper picked in the Material step, sized for
// the cart thumbnail. "" when nothing is selected or the image has no src.
function selectedFinishImageUrl() {
  const img = document.querySelector(
    '[data-option-name="Material"].selected img.active, [data-option-name="Material"].selected img',
  );
  const src = img && (img.currentSrc || img.src);
  if (!src) return "";
  try {
    const url = new URL(src, window.location.origin);
    url.searchParams.set("width", "400");
    return url.toString();
  } catch {
    return src;
  }
}

const DOOR_SEQ_STORAGE_KEY = "brandler:builder:door-seq";
let lastDoorSequence = 0;
function nextDoorSequence() {
  let stored = 0;
  try {
    stored = Number(window.localStorage.getItem(DOOR_SEQ_STORAGE_KEY)) || 0;
  } catch {}
  const seq = Math.max(Date.now(), stored + 1, lastDoorSequence + 1);
  lastDoorSequence = seq;
  try {
    window.localStorage.setItem(DOOR_SEQ_STORAGE_KEY, String(seq));
  } catch {}
  return String(seq);
}

window.nextDoorSequence = nextDoorSequence;

// Door numbers are display ordinals, not permanent identifiers. Count the
// current door lines so deleting a door closes the numbering gap. _DoorSeq
// remains the stable identity used to associate edging/handles with a door.
function computeNextDoorNumber(items) {
  const doorCount = (items || []).filter(
    (item) => item && item.properties && item.properties._DoorSeq,
  ).length;
  return String(doorCount + 1);
}

// Fetch the live cart before adding so the new door gets the next number in
// the current cart. Stable linkage still uses _DoorSeq / _Number, never Door.
async function nextDoorNumber() {
  try {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
    });
    if (!res.ok) return "";
    const cart = await res.json();
    return computeNextDoorNumber(cart.items);
  } catch {
    return "";
  }
}

// Pure part of nextDoorColumn(): the column for a new IKEA door given the
// cart's current items. "Door to the right" starts a new column after the
// highest one in use; "Door above" goes in the column of the most recently
// added door. The first door is always column 1. Like Door numbers, columns
// are stored at add time and never renumbered.
function computeDoorColumn(items, doorType) {
  const builder = getBuilderType();
  let maxColumn = 0;
  let latestColumn = 0;
  let latestSeq = -1;
  (items || []).forEach((item) => {
    const props = item && item.properties;
    if (!props || !props._DoorSeq) return;
    if (builder && props._Builder && props._Builder !== builder) return;
    const column = parseInt(props.Column, 10);
    if (Number.isNaN(column) || column < 1) return;
    if (column > maxColumn) maxColumn = column;
    const seq = Number(props._DoorSeq) || 0;
    if (seq > latestSeq) {
      latestSeq = seq;
      latestColumn = column;
    }
  });
  if (!maxColumn) return "1";
  return String(doorType === "Door above" ? latestColumn : maxColumn + 1);
}

// Fetches the live cart to compute the new door's column. Never throws: on
// any failure it resolves to "" and the door is added without a column.
async function nextDoorColumn(doorType) {
  try {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
    });
    if (!res.ok) return "";
    const cart = await res.json();
    return computeDoorColumn(cart.items, doorType);
  } catch {
    return "";
  }
}

async function refreshCartDrawer() {
  const drawer = document.querySelector("cart-drawer");
  if (drawer && typeof drawer.onCartUpdate === "function") {
    drawer.onCartUpdate();
    drawer.classList.remove("is-empty");
    const innerEmpty = drawer.querySelector(".drawer__inner-empty");
    if (innerEmpty) innerEmpty.remove();
    drawer.querySelector("cart-drawer-items").classList.remove("is-empty");
    const counter = document.querySelector(
      "#cart-icon-bubble .cart-count-bubble",
    );
    const totalPrice = document.querySelector(
      "#CartDrawer .totals__total-value .number",
    );
    const response = await fetch("/cart.js");
    const data = await response.json();
    const innerText = `
					<span aria-hidden="true">${data.items.length}</span>
					<span class="visually-hidden">${data.items.length} item</span>
					`;

    if (totalPrice) {
      totalPrice.innerHTML = (data.items_subtotal_price / 100).toFixed(2);
    }
    if (counter) {
      counter.innerHTML = innerText;
    } else {
      const bubble = document.createElement("div");
      bubble.className = "cart-count-bubble";
      bubble.innerHTML = innerText;
      document.querySelector("#cart-icon-bubble").appendChild(bubble);
    }
  }
}
function addCustomDoorToCart(e, onSuccess) {
  const allSections = document.querySelectorAll(".custom-option-section");
  const calcSections = document.getElementById("custom-calculator");

  let items = [];
  const mainProduct = {
    id: 0,
    quantity: 1,
    properties: {},
  };
  const edge = {
    id: 0,
    quantity: 0,
    properties: {},
  };
  const handle = {
    id: 0,
    quantity: 1,
    properties: {},
  };
  allSections.forEach((elem) => {
    if (elem.classList.contains("colors-option-section")) {
      // Some templates render more than one finish step (e.g. the shelves
      // builder). Keep the last one that actually holds a value so an empty
      // trailing step can't wipe the shopper's choice.
      const color = elem
        .querySelector('.input-cart-option[name="color"]')
        .value.trim();
      if (color) mainProduct.properties["Color"] = color;
    }
    if (elem.classList.contains("door-option-section")) {
      mainProduct.id = Number(
        elem.querySelector('.input-cart-option[name="id"]').value,
      );
    }
    if (elem.classList.contains("edgings-option-section")) {
      const optionAdded = elem.querySelector(
        '.input-cart-option[name="door_option_added"]',
      ).value;
      if (optionAdded === "yes") {
        edge.properties["Edge Type"] = elem.querySelector(
          '.input-cart-option[name="edge_type"]',
        ).value;
        const positionValue = elem
          .querySelector('.input-cart-option[name="edge_position"]')
          .value.trim();
        if (positionValue.includes("Custom:")) {
          // Custom multi-select → "Custom Edge Position: Top, Bottom".
          edge.properties["Custom Edge Position"] = positionValue
            .split(",")
            .map((v) => v.trim().replace(/^Custom:\s*/, ""))
            .filter(Boolean)
            .join(", ");
        } else if (positionValue) {
          edge.properties["Edge Position"] = positionValue;
        }
        edge.id = Number(elem.querySelector('[name="edge_id"]').value);
      }
    }
    if (elem.classList.contains("handles-option-section")) {
      const optionAdded = elem.querySelector(
        '.input-cart-option[name="door_option_added"]',
      ).value;
      if (optionAdded === "yes") {
        handle.properties["Handle"] = elem.querySelector(
          '.input-cart-option[name="handle_title"]',
        ).value;
        handle.properties["Handle Position"] = elem.querySelector(
          '.input-cart-option[name="handle_position"]',
        ).value;
        handle.id = Number(
          elem.querySelector('.input-cart-option[name="handle_id"]').value,
        );
      }
    }
  });
  // The ordered quantity from the calculator (hidden, fixed at 1 on the
  // kitchen/wardrobe templates) — stored as _Qty below so the cart can show
  // an honest count instead of the unit-priced line quantity (60, 340, ...).
  let orderedQty = "";
  if (calcSections) {
    const qtyInput = calcSections.querySelector(
      '[name="properties[Quantity]"]',
    );
    const valQty = Number(qtyInput.value);
    orderedQty = qtyInput.value;
    // mainProduct.properties["Quantity"] = edge.properties["Quantity"] = handle.properties["Quantity"] = handle.quantity = valQty;
    const edgeQuantity = calculateEdgingQuantity(calcSections);
    const mainProdQuantity = calculateMainProdQuantity(calcSections);
    if (edgeQuantity) edge.quantity = edgeQuantity;
    if (mainProdQuantity) mainProduct.quantity = mainProdQuantity;
  }
  mainProduct.properties["Height"] =
    document.querySelector('[name="properties[Height(mm)]"]').value + "(mm)";
  mainProduct.properties["Width"] =
    document.querySelector('[name="properties[Width(mm)]"]').value + "(mm)";
  edge.properties["Height"] =
    document.querySelector('[name="properties[Height(mm)]"]').value + "(mm)";
  edge.properties["Width"] =
    document.querySelector('[name="properties[Width(mm)]"]').value + "(mm)";
  let propNumber = generatePropertyNumber();
  mainProduct.properties["_Number"] =
    edge.properties["_Number"] =
    handle.properties["_Number"] =
      propNumber;
  const doorSeq = nextDoorSequence();
  mainProduct.properties["_DoorSeq"] = doorSeq;
  edge.properties["_DoorRef"] = handle.properties["_DoorRef"] = doorSeq;
  const builderType = getBuilderType();
  if (builderType) {
    mainProduct.properties["_Builder"] =
      edge.properties["_Builder"] =
      handle.properties["_Builder"] =
        builderType;
  }
  items.push(mainProduct);
  if (edge.id > 0) items.push(edge);
  if (handle.id > 0) items.push(handle);

  nextDoorNumber()
    .then((doorNumber) => {
      if (doorNumber) {
        mainProduct.properties["Door"] = doorNumber;
        if (edge.id > 0) edge.properties["Door"] = doorNumber;
        if (handle.id > 0) handle.properties["Door"] = doorNumber;
      }
      // The only visible link from an add-on to its door: what the checkout
      // prints instead of a raw cart line key.
      const doorFor = describeCustomDoorFor(doorNumber);
      if (edge.id > 0) edge.properties["For"] = doorFor;
      if (handle.id > 0) handle.properties["For"] = doorFor;
      // _Qty is the honest ordered count for unit-priced lines; the handle
      // line is priced per handle (quantity is already real), so it's
      // excluded.
      if (orderedQty) {
        mainProduct.properties["_Qty"] = orderedQty;
        if (edge.id > 0) edge.properties["_Qty"] = orderedQty;
      }
      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });
    })
    .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
    .then(({ ok, data }) => {
      // Shopify returns 422 + { status, message } (e.g. inventory / variant
      // errors) instead of rejecting the fetch, so check res.ok explicitly.
      if (!ok) {
        console.warn(
          "[CUSTOM-DOOR] /cart/add.js failed:",
          data && data.message,
        );
        return;
      }

      const addDoorBtn = document.querySelector(".door-builder-add-to-bag");
      if (addDoorBtn) {
        addDoorBtn.disabled = true;
        addDoorBtn.classList.add("disabled", "is-added");
        addDoorBtn.style.opacity = "0.5";
        addDoorBtn.style.cursor = "not-allowed";
        addDoorBtn.style.pointerEvents = "none";
        addDoorBtn.textContent = "✓ Door added";
      }

      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
      setAddAnotherDoorEnabled(true);
      setCustomDoorExitsEnabled(true);
      // ikea-new-setup.js patches window.fetch globally and emits
      // builder:cart-changed for any successful /cart/add.js response; this
      // dispatch is belt-and-braces (works if patch is absent; listeners debounce).
      document.dispatchEvent(new CustomEvent("builder:cart-changed"));
    })
    .catch((err) => {
      console.warn("[CUSTOM-DOOR] /cart/add.js failed:", err);
    });
}

// "Door 2 – Custom Kitchen Doors 600 × 720 mm" for a custom door's add-ons.
function describeCustomDoorFor(doorNumber) {
  const doorSection = document.querySelector(
    ".door-option-section .door_type_grid--item.selected",
  );
  const title = (doorSection && doorSection.dataset.optionValue) || "";
  const width = document.querySelector('[name="properties[Width(mm)]"]')?.value;
  const height = document.querySelector('[name="properties[Height(mm)]"]')?.value;
  const size = width && height ? `${width} × ${height} mm` : "";
  const label = [title, size].filter(Boolean).join(" ");
  return doorNumber ? `Door ${doorNumber} – ${label}` : label;
}

function callCartOpen() {
  window.location.href = "/cart";
}

// Same offset as smoothScrollToElement in product-builder-step2.liquid, so
// every step lands the same distance below the sticky header and the sticky
// selection strip (offset helper lives in product-builder-1.js).
function scrollToBuilderStep(targetEl) {
  const offset = window.brandlerStepScrollOffset ? window.brandlerStepScrollOffset() : 150;
  const top = targetEl.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: top < 0 ? 0 : top, behavior: "smooth" });
}

// Per-door handle reset for the custom-door flow: empties the diagram and the
// stored handle so nothing is added on submit. Used by the "Clear handle
// selection" button and by the full reset below.
function clearCustomHandleSelection(section) {
  section
    .querySelectorAll(".corner-radio.active")
    .forEach((el) => el.classList.remove("active"));
  // Keep the default image visible per handle block — hiding every image
  // collapses the diagram height and breaks the layout below it.
  section.querySelectorAll(".handles-setup").forEach((setup) => {
    setup.querySelectorAll('img[class*="variant-image-"]').forEach((img, i) => {
      img.style.display = "";
      img.classList.toggle("selected", i === 0);
    });
  });
  const idInput = section.querySelector('.input-cart-option[name="handle_id"]');
  const posInput = section.querySelector(
    '.input-cart-option[name="handle_position"]',
  );
  if (idInput) idInput.value = "";
  if (posInput) posInput.value = "";
}

// Custom-door handle dropdown: "Select a handle" (nothing yet), "No handle
// for this door", or a handle size. Shows that size's position picker and
// keeps the handle_* inputs read on "Add this door to your bag" in step, so a
// handle is only added once a size and a position have both been picked.
const CUSTOM_NO_HANDLE_VALUE = "__no_handle__";

function applyCustomHandleChoice(select) {
  const section = select.closest(".handles-option-section");
  if (!section) return;

  const value = select.value;
  const productId = select.selectedOptions[0]?.dataset.productId || "";

  // A new size starts without a position, so the previous size's variant can
  // never be added by mistake.
  clearCustomHandleSelection(section);
  section.querySelectorAll(".handles-setup").forEach((setup) => {
    setup.classList.toggle(
      "active",
      Boolean(productId) && setup.dataset.productId === productId,
    );
  });

  const titleInput = section.querySelector(
    '.input-cart-option[name="handle_title"]',
  );
  if (titleInput) titleInput.value = productId ? value : "";

  // is-no-selection (placeholder) and is-no-handle ("No handle for this door")
  // hide the position picker via CSS, so it only opens for a real handle.
  const list = select.closest('[data-component="handles-list"]');
  if (list) {
    list.classList.toggle("is-no-handle", value === CUSTOM_NO_HANDLE_VALUE);
    list.classList.toggle("is-no-selection", !value);
  }

  hideCustomHandleError(section);
}

document.addEventListener("change", (e) => {
  const select =
    e.target instanceof Element &&
    e.target.closest('handles-setup select[data-component="handle-select"]');
  if (select) applyCustomHandleChoice(select);
});

// Bring the picker in line with whatever the dropdown shows on load (a browser
// restoring the form state can leave a handle selected after a reload).
document
  .querySelectorAll('handles-setup select[data-component="handle-select"]')
  .forEach((select) => applyCustomHandleChoice(select));

// Custom-door handle position. Picking a corner records the handle variant and
// its position (read by addCustomDoorToCart) and swaps the diagram to match.
// Scoped to .handles-option-section: the IKEA flow (ikea-new-setup.js) binds
// its own corner clicks.
document.addEventListener("click", (e) => {
  const radio =
    e.target instanceof Element &&
    e.target.closest(
      '.handles-option-section .handles-setup.active .corner-radio[data-component="option-radio"]',
    );
  if (!radio) return;

  const section = radio.closest(".handles-option-section");
  const setup = radio.closest(".handles-setup");
  const variantId = radio.dataset.variant || "";

  setup
    .querySelectorAll(".corner-radio")
    .forEach((el) => el.classList.toggle("active", el === radio));

  // Swap the diagram only when this position has its own image, so the block
  // never collapses to no image at all.
  const images = Array.from(
    setup.querySelectorAll('img[class*="variant-image-"]'),
  );
  const match = images.find((img) =>
    img.classList.contains(`variant-image-${variantId}`),
  );
  if (match) {
    images.forEach((img) => img.classList.toggle("selected", img === match));
  }

  const idInput = section.querySelector('.input-cart-option[name="handle_id"]');
  const posInput = section.querySelector(
    '.input-cart-option[name="handle_position"]',
  );
  if (idInput) idInput.value = variantId;
  if (posInput) posInput.value = radio.dataset.value || "";

  hideCustomHandleError(section);
});

// "Yes" on the handles step means a handle is wanted, so the door can't go to
// the bag until a handle and its position are both picked (or "No handle for
// this door" is chosen). Capture phase, like the finish gate in
// product-builder-1.js, so the add handler and the fly-to-cart animation never
// run for a blocked click.
function isCustomHandleComplete(section) {
  const added = section.querySelector(
    '.input-cart-option[name="door_option_added"]',
  );
  if (!added || added.value !== "yes") return true;

  const select = section.querySelector(
    'select[data-component="handle-select"]',
  );
  if (select && select.value === CUSTOM_NO_HANDLE_VALUE) return true;

  const id = section.querySelector('.input-cart-option[name="handle_id"]');
  const pos = section.querySelector(
    '.input-cart-option[name="handle_position"]',
  );
  return Boolean(id && id.value && pos && pos.value);
}

function showCustomHandleError(section) {
  const message = section.querySelector("[data-handle-error]");
  if (message) message.hidden = false;
  const target =
    section.querySelector('[data-component="handles-list"]') || section;
  scrollToBuilderStep(target);
}

function hideCustomHandleError(section) {
  const message = section && section.querySelector("[data-handle-error]");
  if (message) message.hidden = true;
}

document.addEventListener(
  "click",
  (e) => {
    // The finish gate (product-builder-1.js) already blocked this click.
    if (e.defaultPrevented) return;
    if (!(e.target instanceof Element)) return;
    const addBtn = e.target.closest(".door-builder-add-to-bag");
    if (!addBtn) return;
    const section = addBtn.closest(".handles-option-section");
    if (!section || isCustomHandleComplete(section)) return;

    e.preventDefault();
    e.stopPropagation();
    showCustomHandleError(section);
  },
  true,
);

// Switching handles to "No" drops the requirement, so drop the message too.
document.addEventListener("change", (e) => {
  const radio =
    e.target instanceof Element &&
    e.target.closest('.handles-option-section .set_hadles input[type="radio"]');
  if (radio) hideCustomHandleError(radio.closest(".handles-option-section"));
});

// Flip a step's Yes/No switcher back to "No" the way a click would, so the
// change listeners (panel visibility, door_option_added, edge/handle price
// inputs) all run.
function resetSwitcherToNo(section) {
  const radio = section.querySelector(
    '.radio_group[data-component="switcher"] input[type="radio"][value="no"]',
  );
  if (!radio) return;
  radio.checked = true;
  radio.dispatchEvent(new Event("change", { bubbles: true }));
  const added = section.querySelector(
    '.input-cart-option[name="door_option_added"]',
  );
  if (added) added.value = "no";
}

// Returns the custom-door Edging and Handles steps to their initial state
// (switchers on "No", no edge or handle picked). Called from "Add another
// door" so the previous door's choices don't carry over to the next one.
function resetCustomDoorOptions() {

  const addDoorBtn = document.querySelector(".door-builder-add-to-bag");
  if (addDoorBtn) {
    addDoorBtn.disabled = false;
    addDoorBtn.classList.remove("disabled", "is-added");
    addDoorBtn.style.opacity = "";
    addDoorBtn.style.cursor = "";
    addDoorBtn.style.pointerEvents = "";
    
    const defaultCtaLabel = addDoorBtn.dataset.originalLabel || "Add this door to your bag";
    addDoorBtn.textContent = defaultCtaLabel;
  }

  const edging = document.querySelector(".edgings-option-section");
  if (edging) {
    edging
      .querySelectorAll(".edge_type.active, .edge_type_option.active")
      .forEach((el) => el.classList.remove("active"));
    const positionInput = edging.querySelector(
      '.input-cart-option[name="edge_position"]',
    );
    if (positionInput) positionInput.value = "";
    resetSwitcherToNo(edging);
    const productEndings = edging.querySelector("product-endings");
    if (productEndings) renderCustomEdgeTotal(productEndings);
  }

  const handles = document.querySelector(".handles-option-section");
  if (handles) {
    // Back to "Select a handle", as rendered on page load.
    const select = handles.querySelector(
      'select[data-component="handle-select"]',
    );
    if (select) {
      select.selectedIndex = 0;
      applyCustomHandleChoice(select);
    }
    resetSwitcherToNo(handles);
  }
}

// The post-add action cards start disabled and unlock in two groups:
// - "Add another door above / to the right" only right after the door being
//   configured has been added, and lock again as soon as the next door is
//   started, so a door can't be skipped.
// - "Go to checkout" / "View panels" once any custom door is in the cart, and
//   then stay unlocked.
function setAddAnotherDoorEnabled(enabled) {
  document.querySelectorAll(".door-builder-add-to-another").forEach((btn) => {
    btn.disabled = !enabled;
  });
}

function setCustomDoorExitsEnabled(enabled) {
  document
    .querySelectorAll(".door-builder-add-to-cart, .door-builder-add-panels")
    .forEach((btn) => {
      btn.disabled = !enabled;
    });
}

// ===== EDGE PRICES on load =====
const EDGE_VARIANT_PRICE_CACHE = new Map();

async function getVariantPriceGBP(variantId) {
  if (!variantId) return null;
  const id = String(variantId);

  if (EDGE_VARIANT_PRICE_CACHE.has(id)) return EDGE_VARIANT_PRICE_CACHE.get(id);

  try {
    const res = await fetch(`/variants/${id}.js`, {
      credentials: "same-origin",
    });
    if (!res.ok) throw new Error(`variants/${id}.js failed: ${res.status}`);
    const data = await res.json();
    const price = typeof data?.price === "number" ? data.price / 100 : null;
    EDGE_VARIANT_PRICE_CACHE.set(id, price);
    return price;
  } catch (e) {
    console.warn("[EDGE-PRICES] Failed to fetch variant price", {
      variantId: id,
      e,
    });
    EDGE_VARIANT_PRICE_CACHE.set(id, null);
    return null;
  }
}

function ensureEdgeTotalPriceNode(optionEl) {
  let nameEl = optionEl.querySelector(".name");

  if (!nameEl) {
    nameEl = document.createElement("div");
    nameEl.className = "name visually-hidden";
    nameEl.textContent = optionEl.dataset.value || "";
    optionEl.prepend(nameEl);
  }

  const existing = optionEl.querySelector(":scope > .edge-total-price");
  if (existing) return existing;

  const priceEl = document.createElement("div");
  priceEl.className = "edge-total-price";
  priceEl.textContent = "";
  nameEl.insertAdjacentElement("afterend", priceEl);
  return priceEl;
}

function initEdgePriceNodes(rootEl) {
  // Only the preset cards get an inline price; the Custom edges are summarised
  // in a single labels list (the circles have no room for per-edge prices).
  rootEl
    .querySelectorAll('.edge_type[data-component="option"]')
    .forEach((el) => ensureEdgeTotalPriceNode(el));
}

// Render a single total price for the custom card, placed above the diagram
// (under the name) so it matches the preset cards.
async function renderCustomEdgeTotal(productEndingsEl) {
  const customCard = productEndingsEl.querySelector(".edge_type--custom");
  if (!customCard) return;

  let totalEl = customCard.querySelector(":scope > .edge-total-price");
  if (!totalEl) {
    totalEl = document.createElement("div");
    totalEl.className = "edge-total-price";
    // Sit the total between the name and the diagram, like the preset cards.
    const nameEl = customCard.querySelector(".name");
    if (nameEl) nameEl.insertAdjacentElement("afterend", totalEl);
    else customCard.prepend(totalEl);
  }

  const selected = Array.from(
    customCard.querySelectorAll(".edge_type_option.active:not(.square)"),
  );

  const calc = document.getElementById("custom-calculator");
  const edgeIdInput =
    document.querySelector('[name="edge_id"]') ||
    document.querySelector('.input-cart-option[name="edge_id"]');
  const edgeVariantId = edgeIdInput?.value ? String(edgeIdInput.value) : null;
  const unitPrice = edgeVariantId
    ? await getVariantPriceGBP(edgeVariantId)
    : null;

  let totalQty = 0;
  if (calc && typeof unitPrice === "number") {
    selected.forEach((el) => {
      totalQty += calculateEdgingQuantityForPosition(calc, el.dataset.value);
    });
  }

  // Keep the price line populated and always visible — it shows £0.00 when
  // nothing is selected, matching the "No Edges" card.
  const total = typeof unitPrice === "number" ? unitPrice * totalQty : 0;
  totalEl.textContent = `£${formatMoneyGBP(total)}`;
  totalEl.style.opacity = "1";
}

function calculateEdgingQuantityForPosition(calcElem, edgePosition) {
  const valQty = Number(
    calcElem.querySelector('[name="properties[Quantity]"]')?.value || 0,
  );
  if (!valQty) return 0;

  const edgeWidth = calcElem.querySelector(
    '[name="properties[Width(mm)]"]',
  )?.value;
  const edgeHeight = calcElem.querySelector(
    '[name="properties[Height(mm)]"]',
  )?.value;

  if (!edgeWidth || !edgeHeight) return 0;

  let edgeLength = 0;
  let edgeDefQuantity = 0;

  if (edgePosition === "All Edges") {
    edgeLength += Number(edgeHeight) * 2;
    edgeLength += Number(edgeWidth) * 2;
    edgeDefQuantity += 40;
  } else if (edgePosition === "Floor Unit" || edgePosition === "Wall Unit") {
    edgeLength += Number(edgeHeight) * 2;
    edgeLength += Number(edgeWidth);
    edgeDefQuantity += 30;
  } else if (edgePosition === "Tall Unit") {
    edgeLength += Number(edgeHeight) * 2;
    edgeDefQuantity += 20;
  } else if (
    edgePosition === "Custom: Left" ||
    edgePosition === "Custom: Right"
  ) {
    edgeLength += Number(edgeHeight);
    edgeDefQuantity += 10;
  } else if (
    edgePosition === "Custom: Top" ||
    edgePosition === "Custom: Bottom"
  ) {
    edgeLength += Number(edgeWidth);
    edgeDefQuantity += 10;
  } else {
    return 0;
  }

  const qtyOnePiece = Math.ceil(edgeLength / 100) + edgeDefQuantity;
  return qtyOnePiece * valQty;
}

function formatMoneyGBP(v) {
  return Number(v).toFixed(2);
}

async function renderEdgePricesInProductEndings(productEndingsEl) {
  const calc = document.getElementById("custom-calculator");
  if (!calc) return;

  const edgeIdInput =
    document.querySelector('[name="edge_id"]') ||
    document.querySelector('.input-cart-option[name="edge_id"]') ||
    null;

  const edgeVariantId = edgeIdInput?.value ? String(edgeIdInput.value) : null;
  initEdgePriceNodes(productEndingsEl);
  renderCustomEdgeTotal(productEndingsEl);

  // "No Edges" is always free, regardless of the selected variant.
  const noEdgesEl = productEndingsEl.querySelector(
    '.edge_type[data-value="No Edges"]',
  );
  if (noEdgesEl) {
    const noEdgesPriceNode = ensureEdgeTotalPriceNode(noEdgesEl);
    if (noEdgesPriceNode)
      noEdgesPriceNode.textContent = `£${formatMoneyGBP(0)}`;
  }

  if (!edgeVariantId) return;

  const unitPrice = await getVariantPriceGBP(edgeVariantId);
  if (typeof unitPrice !== "number") return;

  // Preset cards only — custom edges are handled by renderCustomEdgeTotal.
  const options = productEndingsEl.querySelectorAll(
    '.edge_type[data-component="option"]',
  );

  options.forEach((optionEl) => {
    const pos = optionEl.dataset.value;
    if (!pos || pos === "No Edges") return;

    const qty = calculateEdgingQuantityForPosition(calc, pos);
    const priceNode = ensureEdgeTotalPriceNode(optionEl);

    if (!qty || !priceNode) {
      if (priceNode) priceNode.textContent = "";
      return;
    }

    const total = unitPrice * qty;
    priceNode.textContent = `£${formatMoneyGBP(total)}`;
  });
}

function debounce(fn, delay = 150) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), delay);
  };
}

function setupEdgePriceAutoRender(productEndingsEl) {
  const run = () =>
    renderEdgePricesInProductEndings(productEndingsEl).catch((e) => {
      console.warn("[EDGE-PRICES] render failed", e);
    });

  const runDebounced = debounce(run, 150);

  setTimeout(run, 0);
  setTimeout(run, 300);
  document.addEventListener(
    "input",
    (e) => {
      const t = e.target;
      if (!(t instanceof HTMLElement)) return;
      const isRelevant =
        t.matches('[name="properties[Width(mm)]"]') ||
        t.matches('[name="properties[Height(mm)]"]') ||
        t.matches('[name="properties[Quantity]"]') ||
        t.matches('[name="edge_id"]') ||
        t.matches('.input-cart-option[name="edge_id"]');

      if (isRelevant) runDebounced();
    },
    true,
  );

  document.addEventListener(
    "change",
    (e) => {
      const t = e.target;
      if (!(t instanceof HTMLElement)) return;

      const isRelevant =
        t.matches('[name="properties[Width(mm)]"]') ||
        t.matches('[name="properties[Height(mm)]"]') ||
        t.matches('[name="properties[Quantity]"]') ||
        t.matches('[name="edge_id"]') ||
        t.matches('.input-cart-option[name="edge_id"]');

      if (isRelevant) runDebounced();
    },
    true,
  );
}

// UTILITIES

if (!customElements.get("product-endings")) {
  class ProductEdges extends HTMLElement {
    static get observedAttributes() {
      return ["data-type"];
    }

    constructor() {
      super();
      this.enableSetup = false;
      this.endingsSetup = null;
      this.onListClickHandler = this.onListClickHandler.bind(this);
      this.onListOptionClickHandler = this.onListOptionClickHandler.bind(this);
      this.onSwitcherChange = this.onSwitcherChange.bind(this);
    }

    connectedCallback() {
      this.setElements();
      this.addEventListeners();
      setupEdgePriceAutoRender(this);
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    get type() {
      return this.getAttribute("data-type") || "";
    }
  }

  ProductEdges.prototype.addEventListeners = function () {
    this.addEventListener("click", this.onListClickHandler);
    this.addEventListener("click", this.onListOptionClickHandler);
    if (this.switcher) {
      this.switcher.addEventListener("change", this.onSwitcherChange);
    }
  };

  ProductEdges.prototype.setElements = function () {
    this.endingsSetup = this.querySelector(".endings_setup");
    this.switcher = this.querySelector('[data-component="switcher"');
  };

  ProductEdges.prototype.onSwitcherChange = function (e) {
    if (e.target.value === "yes") {
      this.enableSetup = true;
      this.createAllInputs();
    } else {
      this.enableSetup = false;
      this.removeAllInputs();
    }
  };

  ProductEdges.prototype.removeAllInputs = function () {
    if (this.form) {
      this.form
        .querySelectorAll(".edge_type_input")
        ?.forEach((block) => block.remove());
    }
  };

  ProductEdges.prototype.createAllInputs = function () {
    this.querySelectorAll(".edge_type.active")?.forEach((setup) => {
      const value = setup?.dataset?.value || "";
      const edgesSetupId = setup.closest(".edges_setup")?.id || "";
      this.createFormInput(edgesSetupId, value);
    });
  };

  ProductEdges.prototype.createFormInput = function (id, value) {
    if (!this.form) {
      this.form = document.querySelector(
        ".product__info-container .product-form .form",
      );
    }
    if (!this.form || !id || !value) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = id;
    input.value = value;
    input.className = "edge_type_input";
    this.form.appendChild(input);
  };

  ProductEdges.prototype.updateFormInput = function (id, value) {
    if (!this.form) {
      this.form = document.querySelector(
        ".product__info-container .product-form .form",
      );
    }
    if (!this.form || !id || !value) return;

    const input = this.form.querySelector(`[name="${id}"]`);
    if (!input) return;
    input.value = value;
  };

  ProductEdges.prototype.form = document.querySelector(
    ".product__info-container .product-form .form",
  );

  ProductEdges.prototype.removeEventListeners = function () {
    if (this.switcher) {
      this.switcher.removeEventListener("change", this.onSwitcherChange);
    }
  };

  ProductEdges.prototype.onListClickHandler = function (e) {
    const target = getEventTarget(".edge_type", e.target);
    if (!target || target?.classList?.contains("active")) return;

    const value = target?.dataset?.value || "";
    const edgesSetup = target.closest(".edges_setup");
    const activeEdge = edgesSetup?.querySelector(".edge_type.active");

    if (!target.classList.contains("edge_type--custom")) {
      if (activeEdge) activeEdge.classList.remove("active");
      // Clear the whole custom selection (it can hold several active edges).
      edgesSetup
        ?.querySelectorAll(".edge_type--custom.active, .edge_type_option.active")
        .forEach((el) => el.classList.remove("active"));
      target.classList.add("active");
      this.updateFormInput(edgesSetup.id, value);
    }
  };

  ProductEdges.prototype.onListOptionClickHandler = function (e) {
    const target = getEventTarget(".edge_type_option", e.target);
    if (!target) return;

    // The centre square is decorative / non-interactive.
    if (target.classList.contains("square")) return;

    const edgesSetup = target.closest(".edges_setup");
    const customCard = target.closest(".edge_type--custom");

    // Switching to custom edges clears any active preset card.
    edgesSetup
      ?.querySelectorAll(".edge_type:not(.edge_type--custom).active")
      .forEach((el) => el.classList.remove("active"));

    // Free multi-select: toggle this edge on/off independently.
    target.classList.toggle("active");

    if (customCard) {
      const hasSelection =
        customCard.querySelectorAll(".edge_type_option.active:not(.square)")
          .length > 0;
      customCard.classList.toggle("active", hasSelection);
    }
  };

  customElements.define("product-endings", ProductEdges);
}

if (!customElements.get("door-type")) {
  class DoorType extends HTMLElement {
    constructor() {
      super();
      this.optionName = this?.dataset?.optionName;
    }

    connectedCallback() {
      this.addEventListeners();
    }
  }

  DoorType.prototype.addEventListeners = function () {
    this.addEventListener("click", this.onClickHandler);
  };

  DoorType.prototype.onClickHandler = function () {
    if (!this.ProductEdges) return;
    switch (this.optionName) {
      case "IKEA":
        this.handlesSetup.dataset.type = "ikea";
        this.ProductEdges.dataset.type = "ikea";
        this.nextStep.dataset.selectors = ".ikea-doors-setup__wrapper";
        document.querySelector(".main-product-custom").style.display = "none";
        document
          .querySelectorAll(
            ".section-product-builder2 .custom-option-section:not(.IKEA-step)",
          )
          ?.forEach((section) => section.classList.remove("active"));
        break;
      default:
        this.handlesSetup.dataset.type = "custom";
        this.ProductEdges.dataset.type = "custom";
        this.nextStep.dataset.selectors =
          ".custom-option-section:not(.IKEA-step)";
        document
          .querySelectorAll(".ikea-doors-setup__wrapper")
          ?.forEach((section) => section.classList.remove("active"));
        break;
    }
  };

  DoorType.prototype.handlesSetup = document.querySelector("handles-setup");
  DoorType.prototype.ProductEdges = document.querySelector("product-endings");
  DoorType.prototype.nextStep = document.querySelector("next-step");

  customElements.define("door-type", DoorType);
}

if (!customElements.get("next-step")) {
  class NextStep extends HTMLElement {
    constructor() {
      super();
      this.elementsToOpen = null;
    }

    connectedCallback() {
      this.addEventListeners();
    }

    addEventListeners() {
      this.addEventListener("click", this.onClickHandler.bind(this));
    }

    onClickHandler() {
      this.selectorsToOpen = this.dataset.selectors;
      this.elementsToOpen = document.querySelectorAll(
        `${this.selectorsToOpen}`,
      );

      if (!this.elementsToOpen) return;

      const ikeaSection = document.querySelector(
        ".custom-option-section.IKEA-step",
      );
      const filterSelect = ikeaSection?.querySelector(".filter-select");
      if (filterSelect?.value === "Filter--Panel") {
        return;
      }

      this.elementsToOpen.forEach((element) => {
        element.classList.add("active");
      });

      // Optional: bring the step that just opened into view (the custom-door
      // calculator sets this — the edging step is well below its CTA).
      if (this.dataset.scrollTo) {
        const target = document.querySelector(this.dataset.scrollTo);
        if (target) scrollToBuilderStep(target);
      }
    }
  }

  customElements.define("next-step", NextStep);
}

if (!customElements.get("handles-setup")) {
  class HandlesSetup extends HTMLElement {
    static get observedAttributes() {
      return ["data-type"];
    }

    constructor() {
      super();
      this.enableSetup = false;
      this.endingsSetup = null;
      this.createFormInput = this.createFormInput.bind(this);
      this.updateFormInput = this.updateFormInput.bind(this);
      this.onListClickHandler = this.onListClickHandler.bind(this);
      this.onListOptionClickHandler = this.onListOptionClickHandler.bind(this);
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.onSwitcherChange = this.onSwitcherChange.bind(this);
    }

    connectedCallback() {
      this.setElements();
      this.addEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    get type() {
      return this.getAttribute("data-type") || "";
    }
  }

  HandlesSetup.prototype.addEventListeners = function () {
    this.addEventListener("click", this.onListClickHandler);
    this.addEventListener("click", this.onListOptionClickHandler);
    this.addEventListener("change", this.onSelectChange);

    if (this.submitBtn) {
      this.submitBtn.addEventListener("click", this.onSubmitHandler);
    }

    if (this.switcher) {
      this.switcher.addEventListener("change", this.onSwitcherChange);
    }
  };

  HandlesSetup.prototype.setElements = function () {
    this.endingsSetup = this.querySelector('[data-component="setup"');
    this.submitBtn = this.querySelector('[data-component="submit-button"');
    this.switcher = this.querySelector('[data-component="switcher"');
  };

  HandlesSetup.prototype.onSwitcherChange = function (e) {
    if (e.target.value === "yes") {
      this.enableSetup = true;
      this.createAllInputs();
    } else {
      this.enableSetup = false;
      this.removeAllInputs();
    }
  };

  HandlesSetup.prototype.onSubmitHandler = function () {
    this.submitBtn.disabled = true;
    this.submitBtn.classList.add("loading");
    if (!this.form) {
      this.form = document.querySelector(
        ".product__info-container .product-form .form",
      );
    }
    if (!this.form) return;

    this.form.querySelector(".product-form__submit").click();
  };

  HandlesSetup.prototype.createAllInputs = function () {
    this.querySelectorAll(
      '[data-component="option-radio"].active, [data-component="option"].active',
    )?.forEach((setup) => {
      const value = setup?.dataset?.value || "";
      const edgesSetupId =
        setup.closest('[data-component="options-list"]')?.id || "";
      this.createFormInput(edgesSetupId, value);
    });

    this.querySelectorAll('[data-component="select"]')?.forEach((select) => {
      const id = select?.dataset?.id;
      this.createFormInput(id, select.value);
    });
  };

  HandlesSetup.prototype.removeAllInputs = function () {
    if (this.form) {
      this.form
        .querySelectorAll(`.${this.dataset.property}_input`)
        ?.forEach((block) => block.remove());
    }
  };

  HandlesSetup.prototype.createFormInput = function (id, value) {
    if (!this.form) {
      this.form = document.querySelector(
        ".product__info-container .product-form .form",
      );
    }
    if (!this.form || !id || !value) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = id;
    input.value = value;
    input.className = `${this.dataset.property}_input`;

    this.form.appendChild(input);
  };

  HandlesSetup.prototype.updateFormInput = function (id, value) {
    if (!this.form) {
      this.form = document.querySelector(
        ".product__info-container .product-form .form",
      );
    }

    if (!this.form || !id) return;

    const input = this.form.querySelector(`[name="${id}"]`);
    if (!input) return;
    input.value = value;
  };

  HandlesSetup.prototype.updateHandlesPrice = function () {
    const quantityInput = document.querySelector(
      'input[data-identifier="Quantity"]',
    );
    const handlessInput = document.querySelector(
      'input[data-identifier="Handless"]',
    );
    if (!quantityInput || !handlessInput) return;
    const quantity = parseInt(quantityInput.value, 10) || 0;
    const handleInputs = document.querySelectorAll(".handle_input");
    const handleValue = handleInputs.length / 2;
    handlessInput.value = handleValue;
  };

  HandlesSetup.prototype.createEdgesList = (ind = 0, key = "") => {
    const listHandles = document.createElement("div");
    listHandles.classList.add("list");
    listHandles.setAttribute("data-item-key", key);

    listHandles.innerHTML = `
			<h2>Custom door ${ind + 1}</h2>
			<input type="hidden" name="item-key" value="${key}">
			<input type="hidden" name="propperties" value="Handles">
			<select data-id="properties[Custom Door ${
        ind + 1
      } Handle]" data-component="select">
				<option value="60 mm Cabinet Corner Handle 1">60 mm Cabinet Corner Handle</option>
				<option value="100 mm Cabinet Corner Handle 2">100 mm Cabinet Corner Handle</option>
				<option value="120 mm Cabinet Corner Handle 3">120 mm Cabinet Corner Handle</option>
				<option value="200 mm Cabinet Corner Handle 4">200 mm Cabinet Corner Handle</option>
			</select>
			<div class="handles-setup" id="properties[Custom Door ${
        ind + 1
      } Handle Setup]" data-component="options-list">
				<div class="grid">
					<div class="grid__item handles-setup__item handles-setup__item--radio" data-component="option">
						<div class="corner-radio-block">
							<div class="corner-radio corner-tl active" data-value="Top left" data-component="option-radio"></div>
							<div class="corner-radio corner-tr" data-value="Top right" data-component="option-radio"></div>
							<div class="corner-radio corner-bl" data-value="Bottom left"  data-component="option-radio"></div>
							<div class="corner-radio corner-br" data-value="Bottom right" data-component="option-radio"></div>
						</div>
					</div>
					<div class="grid__item unselectable" data-component="option" data-value="Handle">
						<img src="https://cdn.shopify.com/s/files/1/0881/0676/2585/files/handle.png?v=1749118339" alt="handle">
					</div>
				</div>
			</div>
		`;

    return listHandles;
  };

  HandlesSetup.prototype.form = document.querySelector(
    ".product__info-container .product-form .form",
  );

  HandlesSetup.prototype.removeEventListeners = function () {
    this.removeEventListener("click", this.onListClickHandler);
    this.removeEventListener("click", this.onListOptionClickHandler);
    this.removeEventListener("change", this.onSelectChange);

    if (this.submitBtn) {
      this.submitBtn.removeEventListener("click", this.onSubmitHandler);
    }
  };

  HandlesSetup.prototype.onListClickHandler = function (e) {
    const target = getEventTarget('[data-component="option"]', e.target);
    if (!target || target?.classList?.contains("active")) return;

    const value = target?.dataset?.value || "";
    const edgesSetup = target.closest('[data-component="options-list"]');
    const activeEdge = edgesSetup?.querySelector(
      '[data-component="option"].active',
    );

    if (!target.querySelector('[data-component="option-radio"]')) {
      if (activeEdge) activeEdge.classList.remove("active");
      edgesSetup
        ?.querySelector('[data-component="option-radio"].active')
        ?.classList.remove("active");
      target.classList.add("active");
    }
  };

  HandlesSetup.prototype.onListOptionClickHandler = function (e) {
    const target = getEventTarget('[data-component="option-radio"]', e.target);
    if (!target || target?.classList?.contains("active")) return;

    const value = target?.dataset?.value || "";
    const edgesSetup = target.closest('[data-component="options-list"]');
    const activeEdge = target
      .closest('[data-component="options-list"]')
      ?.querySelector('[data-component="option"].active');

    if (activeEdge) activeEdge.classList.remove("active");

    const edgeType = target.closest('[data-component="option"]');

    if (edgeType) {
      edgeType.classList.add("active");
      edgeType
        .querySelector('[data-component="option-radio"].active')
        ?.classList.remove("active");
    }

    target.classList.add("active");
    this.updateFormInput(edgesSetup.id, value);
    this.updateHandlesPrice();
  };

  HandlesSetup.prototype.onSelectChange = function (e) {
    const id = e.target?.dataset?.id;
    const value = e.target.value;
    this.updateFormInput(id, value);
    this.updateHandlesPrice();
  };

  customElements.define("handles-setup", HandlesSetup);
}
function calculateEdgingQuantity(elem) {
  const edgePosition = document.querySelector(
    '.input-cart-option[name="edge_position"]',
  ).value;
  if (!edgePosition) return false;

  // Sum every selected position (custom edges can hold several at once).
  return edgePosition
    .split(",")
    .map((pos) => pos.trim())
    .filter(Boolean)
    .reduce(
      (total, pos) => total + calculateEdgingQuantityForPosition(elem, pos),
      0,
    );
}

function calculateMainProdQuantity(elem) {
  const valQty = Number(
    elem.querySelector('[name="properties[Quantity]"]').value,
  );
  const edgeWidth = elem.querySelector('[name="properties[Width(mm)]"]').value;
  const edgeHeight = elem.querySelector(
    '[name="properties[Height(mm)]"]',
  ).value;
  const s = Math.ceil((edgeWidth * edgeHeight) / 10000);
  return s * valQty;
}
})();
